<div class="industry-analysis-page">
  <div class="content">
    <div class="top-action-section mb-16">
      <div class="filter-container">
        <div class="filter">
          <app-lineitem-filter
            [options]="lineItemsData"
            [selectedValue]="
              !isLineUpdateInProgress && lineItem
                ? { value: lineItem.uniquesliid, label: lineItem.name }
                : {}
            "
            [selectedOptionsId]="lineItem ? [lineItem.uniquesliid] : undefined"
            liFilterId="industry{{ pageShortName }}LI"
            [bottomBorderView]="true"
            [disabled]="
              isMetaInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            placeholder="&nbsp;Add Line Item"
            [showLabel]="true"
            label="Line Items"
            [showButton]="false"
            (onValueChange)="handleLineItemSelection($event)"
          ></app-lineitem-filter>
          <!-- <app-lineitem-with-searchbox-in-dropdown
            [stdLines]="lineItemsData"
            [selectedLineItem]="lineItem"
            [suggestedLines]="suggestedLineItems"
            [disabled]="
              isMetaInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            lineItemInputId="industryCoreLineItemInput"
            (onLineItemSelection)="handleLineItemSelection($event)"
          >
          </app-lineitem-with-searchbox-in-dropdown> -->
        </div>
        <div class="filter">
          <app-toggle-checkbox
            [disabled]="
              isMetaInProgress ||
              isDataInProgress ||
              isUserSettingUpdateInProgress ||
              !lineItem
            "
            [checkboxValue]="showBlankRows"
            [label]="showBlankRowsLabel"
            labelInfo="Consensus values do not exist for all companies in all time periods."
            (onCheckboxChange)="handleShowBlanksSwitchChange($event)"
          ></app-toggle-checkbox>
        </div>
      </div>
      <div class="cta-right-section">
        <button
          class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
          [ngClass]="[
            isExportPopoverVisible ? 'va-button--active' : '',
            isDataInProgress ||
            isMetaInProgress ||
            !lineItem ||
            !tickers ||
            !tickers.length ||
            !gridData
              ? 'va-button--disabled'
              : ''
          ]"
          nz-popover
          nzPopoverTrigger="click"
          [nzPopoverContent]="exportOptionsTemplate"
          nzPopoverPlacement="bottomRight"
          [(nzPopoverVisible)]="isExportPopoverVisible"
          title="Export Table"
        >
          <va-icon
            size="small"
            *ngIf="!isExportInProgress; else exportLoading"
            name="file-excel"
            class="va-button-icon"
          ></va-icon>
        </button>
      </div>
    </div>
    <div class="grid-section">
      <app-comparison-grid
        [gridData]="gridData"
        [magnitudeMessage]="magnitudeMessage"
        [isDataInProgress]="isDataInProgress"
        [sortByColumnId]="
          pageShortName === pageNameData.industrySurprise
            ? surpriseInititalSortColumnKey
            : revisionInititalSortColumnKey
        "
        [sortByDirection]="
          pageShortName === pageNameData.industrySurprise ? 'asc' : 'desc'
        "
        [showBlankRows]="showBlankRows"
        [hasFormulaBar]="true"
        [selectedCell]="selectedCell"
        [selectedRow]="selectedRow"
        (handleCellClick)="createDpParam($event)"
        (rowClick)="handleRowClick($event)"
      ></app-comparison-grid>
    </div>
  </div>
</div>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon name="check" class="snack-icon snack-success-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon name="close-circle" class="snack-icon snack-failure-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon name="info-circle" class="snack-icon snack-info-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>

<ng-template #exportOptionsTemplate>
  <div (click)="exportValue(1)" class="comp-export-opt">Values</div>
  <div (click)="exportValue(0)" class="comp-export-opt">
    Excel Add-In Formulas
  </div>
</ng-template>
<ng-template #exportLoading>
  <div>
    <ng-template #indicatorTemplate>
      <va-icon
        isFontAwesome="true"
        name="faSpinner"
        [spin]="true"
        class="va-button-icon"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </div>
</ng-template>

<app-no-ticker-popup
  [showNoTickerPopup]="isNoTickerPopupVisible"
  (onNoTickerPopupChangeClick)="onNoTickerPopupChangeClick()"
></app-no-ticker-popup>
